<!-- 文字配置 -->
<template>
  <div>
    <el-form-item label="显示模式">
      <el-select :value="main.activeOption.textPresentation === 'metric' ? 'metric' : 'plain'" aria-label="文本显示模式" @input="$set(main.activeOption, 'textPresentation', $event)">
        <el-option label="普通文本" value="plain" />
        <el-option label="指标文本" value="metric" />
      </el-select>
    </el-form-item>
    <page-product-text-options />
    <el-form-item v-if="!['pageProduct', 'pageDevice', 'pageDeviceId'].includes(main.activeOption.textSource)" label="文本内容">
      <avue-input v-model="main.activeObj.data.value"></avue-input>
    </el-form-item>
    <el-form-item :label="metric ? '主内容字号' : '字体大小'">
      <avue-input-number v-model="main.activeOption.fontSize"
                         :max="200"></avue-input-number>
    </el-form-item>
    <el-form-item :label="metric ? '主内容颜色' : '字体颜色'">
      <avue-input-color v-model="main.activeOption.color"></avue-input-color>
    </el-form-item>
    <el-form-item label="字体间距">
      <avue-slider v-model="main.activeOption.split"></avue-slider>
    </el-form-item>
    <el-form-item v-if="!metric" label="字体行高">
      <avue-slider v-model="main.activeOption.lineHeight"></avue-slider>
    </el-form-item>
    <el-form-item label="字体背景">
      <avue-input-color v-model="main.activeOption.backgroundColor"></avue-input-color>
    </el-form-item>
    <el-form-item label="文字粗细">
      <avue-select v-model="main.activeOption.fontWeight"
                   :dic="dicOption.fontWeight">
      </avue-select>
    </el-form-item>
    <el-form-item label="文字字体">
      <avue-select v-model="main.activeOption.fontFamily"
                   :dic="dicOption.fontFamily">
      </avue-select>
    </el-form-item>
    <el-form-item label="对齐方式">
      <avue-select v-model="main.activeOption.textAlign"
                   :dic="dicOption.textAlign">
      </avue-select>
    </el-form-item>
    <text-metric-options v-if="metric" />
    <el-collapse accordion>
      <el-collapse-item v-if="!metric" title="跑马灯设置">
        <el-form-item label="开启">
          <avue-switch v-model="main.activeOption.scroll"></avue-switch>
        </el-form-item>
        <template v-if="main.activeOption.scroll">
          <el-form-item label="滚动速度">
            <avue-input v-model="main.activeOption.speed"></avue-input>
          </el-form-item>
        </template>
      </el-collapse-item>
      <el-collapse-item title="超链设置">
        <el-form-item label="开启">
          <avue-switch v-model="main.activeOption.link"></avue-switch>
        </el-form-item>
        <template v-if="main.activeOption.link">
          <el-form-item label="打开方式">
            <avue-radio v-model="main.activeOption.linkTarget"
                        :dic="dicOption.target">
            </avue-radio>
          </el-form-item>
          <el-form-item label="超链地址">
            <avue-input v-model="main.activeOption.linkHref"></avue-input>
          </el-form-item>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { dicOption } from '@/option/config'
import PageProductTextOptions from './page-product-text'
import TextMetricOptions from './text-metric'
export default {
  components: { PageProductTextOptions, TextMetricOptions },
  data () {
    return {
      dicOption: dicOption
    }
  },
  computed: { metric () { return this.main.activeOption.textPresentation === 'metric' } },
  inject: ["main"]
}
</script>

<style>
</style>
